import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './v2/queryClient';
import App from './App';

const AppWithQueryProvider = () => (
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);

export default AppWithQueryProvider;
